import './App.css';
import './assets/argon-dashboard-tailwind.css';
import { app, getUserDoc } from './firebase.js';
import { getAuth } from 'firebase/auth';
import { SignIn } from './authentication.js';
import { useAuthState } from 'react-firebase-hooks/auth';
import { updateDoc } from 'firebase/firestore';
import { lazy, Suspense, useEffect, useState } from 'react';

import User from './Components/User.js';

import TestsMenu from './Components/Tests.js';
//Imports para menu
import { NavLink, Route, Routes } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faCartShopping, faTicket, faUser,faPlus } from '@fortawesome/free-solid-svg-icons';
import { ViewOwnedTicketRaves, ViewTicketRoute, ViewRaves, RoleChange, Profile, Home, ConfirmPurchase } from './Components/User.js';

const Scanner = lazy(() => import("./Components/Scanner.js"));
const Admin = lazy(() => import("./Components/Admin.js"));
const RP = lazy(() => import("./Components/RP.js"));

function AdultCheck({ onConfirm }) {
  const [step, setStep] = useState(0);

  if (step === 0) {
    return (
      <div className="margen">
        <h1 className='title'>LOOKING FOR A PARTY?</h1>
        <div className="link-container">
          <button className="hov age-confirm-button" onClick={() => setStep(1)}>YES</button>
          <button
            className="hov age-confirm-button"
            onClick={() => window.location.href = 'https://youtu.be/XqZsoesa55w?si=m08CYZRAT1FGRkmN'}
          >
            NO
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="margen">
      <h1 className='title'>18+?</h1>
      <div className="link-container">
        <button className="hov age-confirm-button" onClick={() => onConfirm(true)}>YES</button>
        <button
          className="hov age-confirm-button"
          onClick={() => window.location.href = 'https://youtu.be/XqZsoesa55w?si=m08CYZRAT1FGRkmN'}
        >
          NO
        </button>
      </div>
    </div>
  );
}

function MainContainerScreen({customClaims}) {
  const [showList, setShowList] = useState(true);

  const menuItems = ["home", "raves", "ticketRaves"];
  const menuIconst = [faHouse, faCartShopping, faTicket];
  const roles = ["Scanner", "RP", "Admin"];
  
  return (
    <>
      <nav className="nav">
        <ul className="nav__list">
          {/* First two menu items */}
          {menuItems.slice(0, 2).map((item, index) => (
            <li key={index}>
              <NavLink
                to={item}
                className={({ isActive }) =>
                  `nav__link ${isActive ? 'active-link' : ''}`
                }
              >
                <FontAwesomeIcon icon={menuIconst[index]} />
              </NavLink>
            </li>
          ))}

          {/* Expand list button with faPlus */}
          {(customClaims && customClaims.length > 0) && (
            <li
              className="nav__expand-btn"
              onClick={(e) => {
                e.stopPropagation();
                setShowList(!showList);
              }}
              onMouseEnter={() => setShowList(true)}
              style={{ cursor: "pointer" }}
            >
              <span className="nav__link">
                <div className="plus">
                  <FontAwesomeIcon icon={faPlus} className={`plus-icon ${showList ? 'rotate-icon' : ''}`}/>
                </div>
              </span>
              {/* Expanded list */}
              <ul
                onClick={() => setShowList(!showList)}
                className={`nav__expand-list${showList ? ' show-list' : ''}`}
                id="nav-expand-list"
              >
                {roles.map((role, index) => (
                  (customClaims.includes(role.toLowerCase()) || customClaims.includes("admin")) && (
                    <li key={index}>
                      <NavLink to={`/${role.toLowerCase()}`} className={({ isActive }) =>
                        `nav__expand-link ${isActive ? 'active-link' : ''}`
                      }>{role}</NavLink>
                    </li>
                  )
                ))}
              </ul>
            </li>
          )}

          {/* Last menu item (faTicket) */}
          <li>
            <NavLink
              to={menuItems[2]}
              className={({ isActive }) =>
                `nav__link ${isActive ? 'active-link' : ''}`
              }
            >
              <FontAwesomeIcon icon={menuIconst[2]}/>
            </NavLink>
          </li>

          {/* Profile icon */}
          <li>
            <NavLink
              to="/profile"
              className={({ isActive }) =>
                `nav__link ${isActive ? 'active-link' : ''}`
              }
            >
              <FontAwesomeIcon icon={faUser} />
            </NavLink>
          </li>
        </ul>
      </nav>
        
      <Routes>
        {/* Rutas siempre visibles */}
        <Route path="/" element={<Home />} />
        <Route path="/raves" element={<ViewRaves />} />
        <Route path="/:repId" element={<ViewRaves />} />
        <Route path="/ticket/:raveId/:ticketId/:ticketType" element={<ViewTicketRoute />} />
        <Route path="/ticketRaves" element={<ViewOwnedTicketRaves />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/home" element={<Home />} />
        <Route path="/confirmPurchase" element={<ConfirmPurchase />} />
        <Route path="role_change/scanner/:raveId/:role_key" element={<RoleChange role="scanner" />} />
        <Route path="role_change/rp/:raveId/:role_key" element={<RoleChange role="rp" />} />
        <Route path="tests/*" element={<TestsMenu />} />

        {/* Rutas en base a roles */}
        {(customClaims && customClaims.length > 0) && (
          <>
            {customClaims.includes("admin") && (
              <Route path="/admin/*" element={<Admin />} />
            )}
            {(customClaims.includes("scanner") || customClaims.includes("admin")) && (
              <Route path="/scanner/*" element={<Scanner />} />
            )}
            {(customClaims.includes("rp") || customClaims.includes("admin")) && (
              <Route path="/rp/*" element={<RP />} />
            )}
          </>
        )}
      </Routes>
    </>
  );
}

function MainContainer({ user }) {
  const [customClaims, setCustomClaims] = useState(null);

  useEffect(() => {
    const fetchCustomClaims = async () => {
      const auth = getAuth(app);
      const user = auth.currentUser;
  
      if (user) {
        try {
          const idTokenResult = await user.getIdTokenResult();
          const roles = idTokenResult.claims.roles;
          setCustomClaims(roles ? Object.keys(roles).filter(role => roles[role]) : []);
        } catch (err) {
          console.error("Error fetching custom claims:", err);
        }
      }
    };
  
    fetchCustomClaims();
  }, [user]);

  return (
    <MainContainerScreen customClaims={customClaims} />
  );
}

function App() {
  const auth = getAuth(app);
  const [user, loading, error] = useAuthState(auth);
  const [adult, setAdult] = useState(false);
  const linkActive = window.location.pathname.length > 1;

  return (
    <>
      {loading && <h1 className="text-center">Loading...</h1>}
      {error && <h1>Error</h1>}

      {!loading && !error && (
        <div className="cont">
          {((user || adult || linkActive) ? 
            (<MainContainer user={user} />) : 
            (<AdultCheck onConfirm={() => setAdult(true)} />))
          }
        </div>
      )}
    </>
  );
}

export default App;